export default function SkeletonCard() {
  return (
    <div className="premium-drop-card skeleton-card">
      <div className="premium-drop-top">
        <div className="premium-creator-link">
          <div className="skeleton-image premium-creator-avatar" />

          <div style={{ flex: 1 }}>
            <div className="skeleton-line" />
            <div className="skeleton-line short" />
          </div>
        </div>
      </div>

      <div className="skeleton-image premium-drop-media" />

      <div className="premium-drop-body">
        <div className="skeleton-line" />
        <div className="skeleton-line short" />
      </div>
    </div>
  );
}